<template>
	<div class="ReUploadDocs">
		<div class="super_container" v-for="(upload, obj_index) in value" :key="obj_index">
			<div class="fields">
				<!--
				<input type="text" placeholder="Название" class="form-control" v-model.lazy="upload.name">
				<input type="text" placeholder="Ссылка" class="form-control" v-model.lazy="upload.link" v-if="!bShowLink">
				-->
				<base-input
					:name="'Название_'+(obj_index+1)"
					placeholder="Название"
					v-validate="validation.required" 
					v-model.lazy="upload.name"
					:error="getError('Название_'+(obj_index+1))">
				</base-input>
				<base-input v-if="!bShowLink"
					:name="'Ссылка_'+(obj_index+1)"
					placeholder="Ссылка"
					v-validate="validation.web" 
					v-model.lazy="upload.link"
					:error="getError('Ссылка_'+(obj_index+1))">
				</base-input>
				<div v-else><h6 class="d-inline m-0 mr-2">Ссылка:</h6><a target="_blank" :href="upload.link">{{upload.name}}</a></div>
				<textarea placeholder="Описание" class="form-control" v-model.lazy="upload.desct"></textarea>
			</div>
			<div class="actions">
				<ReFileUpload v-if="upload.link==''" type="file" @change="UploadFile" :bShowTrash="false" :formId="'uploadForm_'+obj_index" acceptMime="*/*"/>
				<button class="ml-2 btn btn-icon btn-simple btn-danger" @click="DoDel(obj_index)">
					<i class="tim-icons icon-trash-simple"></i>
				</button>
			</div>
		</div>
		<div class="spinner" v-if="bUploading">Загрузка</div>
		<button v-if="value.length < limit" class="btn btn-icon btn-simple btn-primary" @click="addEmptyUpload()">
			<i class="tim-icons icon-simple-add"></i>
		</button>
	</div>
</template>

<script>
	import ReFileUpload from 'src/our_components/ReFileUpload.vue';

	export default {
		name: 'ReUploadDocs',
		components: {
			ReFileUpload
		},
		props: {
			value: Array,
			limit: {
				type:Number,
				default:100000,
			}
		},
		data () {
			return {
				ver: 1,
				bShowLink: false,
				validation:{
					required: {
						required: true,
						min: 3
					},
					/*
					web:{
						//required: true,
						url: {require_protocol: false }
					},
					*/
				},
				bUploading:false,
			}
		},
		computed: {

		},
		methods: {
			addEmptyUpload(){
				this.value.push({
					id: '',
					name: '',
					desct: '',
					link: '',
					act: true,
				});
			},
			DoAtt(objIndex){
				let bValid = false;
				this.$validator.validateAll().then(isValid => {
					bValid = isValid;
				});
				if(bValid){
					
					if(this.value[objIndex].upload_link != ''){
						this.bShowLink=true;
					}
				}
			},
			DoDel(objIndex){
				//console.log('DoDel',this.value[objIndex].id);
				this.$GVO.ApiCall('DEL_TASK_HELP',{obj:'BP',flt:{id:this.value[objIndex].id} })
					.then((objApi) => {
						if(objApi.success === true){
							//console.log(objApi);
							this.value.splice(objIndex, 1);
						}
					}).catch(errorObjApi => console.error(errorObjApi));
			},
			UploadFile(objData){
				this.bUploading=true;
				const objIndex = objData.formId.match(/[0-9/.]+/)[0];
				let objSendApi = {obj:'FileUpload',flt:{BP_ID:this.$route.params.bp_id, 'type': 'task_help'}};
				if(typeof this.$route.params.type_id != 'undefined'){
					objSendApi.flt.id = this.$route.params.type_id;
				}
				this.$GVO.UploadFile(objData.formId,'UploadTaskHelp',objSendApi)
					.then(objApi => {  
						//console.log(objApi);
						if(objApi.success){
							this.value[objIndex].link = objApi.data.fullpath;
						}else{
							alert(objApi.msg);
						}
						this.bUploading=false;
					})
					.catch(errorObjApi => 	{  console.error(errorObjApi); this.bUploading=false;});
			},
			getError(fieldName) {
				return this.errors.first(fieldName);
			},
		},
	}
</script>
<style scoped>
	.fields > *{margin-bottom: 10px;}
	.actions > *{margin-top: 0px;}
</style>
